export class VetologyPager extends HTMLElement
{
    static observedAttributes = ['total-items', 'per-page', 'page'];

    connectedCallback()
    {
        this.render();
        this.addEventListener('click', event => this.handleClick(event));
        this.addEventListener('change', event => this.handlePerPageChange(event));
    }

    attributeChangedCallback(name, oldValue, newValue)
    {
        if (this.isConnected && oldValue !== newValue) {
            this.render();
        }
    }

    get page()       { return Math.max(1, parseInt(this.getAttribute('page')) || 1); }
    get perPage()    { return parseInt(this.getAttribute('per-page')) || 25; }
    get totalItems() { return parseInt(this.getAttribute('total-items')) || 0; }
    get totalPages() { return Math.max(1, Math.ceil(this.totalItems / this.perPage)); }
    get labelText()  { return this.getAttribute('label') || 'Per Page'; }

    get perPageOptions()
    {
        return (this.getAttribute('per-page-options') || '25,50,100')
            .split(',')
            .map(option => parseInt(option));
    }

    handleClick(event)
    {
        const button = event.target.closest('button[data-page]');
        if (!button || button.disabled) {
            return;
        }
        this.turnTo(parseInt(button.dataset.page));
    }

    handlePerPageChange(event)
    {
        if (!event.target.matches('select.per-page')) {
            return;
        }
        this.setAttribute('per-page', event.target.value);
        this.setAttribute('page', 1);
        this.emit('pager:per-page-change');
    }

    turnTo(page)
    {
        page = Math.min(Math.max(1, page), this.totalPages);
        if (page === this.page) {
            return;
        }
        this.setAttribute('page', page);
        this.emit('pager:page-change');
    }

    emit(name)
    {
        this.dispatchEvent(new CustomEvent(name, {
            bubbles: true,
            detail: { page: this.page, perPage: this.perPage }
        }));
    }

    /** first + last + current±2, ascending, null marking each ellipsis gap */
    pageWindow()
    {
        const pages = new Set([1, this.totalPages]);
        for (let p = this.page - 2; p <= this.page + 2; p++) {
            if (p >= 1 && p <= this.totalPages) {
                pages.add(p);
            }
        }
        const sorted = [...pages].sort((a, b) => a - b);
        const windowed = [];
        sorted.forEach((p, i) => {
            if (i > 0 && p - sorted[i - 1] > 1) {
                windowed.push(null);
            }
            windowed.push(p);
        });
        return windowed;
    }

    render()
    {
        const numbers = this.totalPages === 1 ? '' : `
            <span class="page-numbers">
                <button data-page="${this.page - 1}" ${this.page === 1 ? 'disabled' : ''}>&lsaquo;</button>
                ${this.pageWindow().map(p => p === null
                    ? '<span class="gap">…</span>'
                    : `<button data-page="${p}" class="${p === this.page ? 'current' : ''}">${p}</button>`
                ).join('')}
                <button data-page="${this.page + 1}" ${this.page === this.totalPages ? 'disabled' : ''}>&rsaquo;</button>
            </span>`;

        this.innerHTML = `
            <label class="per-page-label">
                <select class="per-page">
                    ${this.perPageOptions.map(option =>
                        `<option value="${option}" ${option === this.perPage ? 'selected' : ''}>${option}</option>`
                    ).join('')}
                </select>
                ${this.labelText}
            </label>
            ${numbers}`;
    }
}

customElements.define('vetology-pager', VetologyPager);
